import { cn } from '@/lib/utils'

interface LinearProgressProps {
    className?: string
    /** Classe da onda animada no modo indeterminado. */
    colorBgClass?: string
    variant?: 'determinate' | 'indeterminate'
    /** Valor de 0 a 100, usado quando `variant="determinate"`. */
    value?: number
    color?: 'primary' | 'inherit'
}

export default function LinearProgress({
    className,
    colorBgClass = 'bg-card',
    variant = 'indeterminate',
    value = 0,
    color = 'primary',
}: LinearProgressProps) {
    const determinate = variant === 'determinate'
    const trackClass = color === 'inherit' ? 'bg-current/30' : 'bg-primary/20'
    const barClass = color === 'inherit' ? 'bg-current' : 'bg-primary'

    return (
        <div
            role="progressbar"
            aria-valuenow={determinate ? Math.round(value) : undefined}
            aria-valuemin={0}
            aria-valuemax={100}
            className={cn(
                'relative h-1 w-full overflow-hidden',
                determinate ? trackClass : 'bg-primary',
                className,
            )}
        >
            {determinate ? (
                <div
                    className={cn(
                        'h-full transition-[width] duration-200',
                        barClass,
                    )}
                    style={{
                        width: `${Math.min(100, Math.max(0, value))}%`,
                    }}
                />
            ) : (
                <div
                    className={cn(
                        'absolute inset-0 size-full animate-wave',
                        colorBgClass,
                    )}
                />
            )}
        </div>
    )
}
